import messages from './messages';

export type MovementType = 'OUT' | 'TRANSFERT';

export const MOVEMENT_TYPE = [
  {label: messages.moveOut, id: 'OUT'},
  {label: messages.moveTransfer, id: 'TRANSFERT'},
];
